/**
 * Tariff List V2 - Mobile accordion with exclusive open behavior.
 * On mobile (<768px), clicking the header area (grade/info/toggle) toggles the
 * expandable content and prevents the <a> link navigation.
 * On desktop (>=768px), the entire row acts as a normal link.
 */
function smoothScrollTo(startY, targetY, duration) {
    const diff = targetY - startY;
    let startTime = null;

    function step(timestamp) {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        const ease = progress < 0.5
            ? 2 * progress * progress
            : -1 + (4 - 2 * progress) * progress;
        document.body.scrollTo(0, startY + diff * ease);
        if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.mod24TarifeV2').forEach(container => {
        const tariffs = container.querySelectorAll('.tarif-v2');

        tariffs.forEach(tarif => {
            const grade = tarif.querySelector('.tarif-v2__grade');
            const info = tarif.querySelector('.tarif-v2__info');
            const toggle = tarif.querySelector('.tarif-v2__toggle');

            [grade, info, toggle].filter(Boolean).forEach(el => {
                el.addEventListener('click', (e) => {
                    if (window.innerWidth >= 768) return;

                    e.preventDefault();
                    e.stopPropagation();

                    const isOpen = tarif.classList.contains('is-open');
                    tariffs.forEach(other => other.classList.remove('is-open'));
                    if (!isOpen) {
                        tarif.classList.add('is-open');
                        setTimeout(() => {
                            const startY = document.body.scrollTop;
                            const targetY = startY + tarif.getBoundingClientRect().top;
                            smoothScrollTo(startY, targetY, 400);
                        }, 150);
                    }
                });
            });
        });
    });
});
